// Copyright © Veeam Software Group GmbH

import type { RbacInfo } from 'services/rbac/types';

import { StorageKeys } from '../StorageKeys';
import { getLocalStorage } from '../rawStorage';

export const rbacStorage = getLocalStorage<RbacInfo>(StorageKeys.Rbac);
